module.exports = __webpack_public_path__ + "img/Semper_Fi_Cycle@2x.b34ca1b1.webp";